import React  from 'react';

// Images.
import { ReactComponent as LogoIcon } from './images/logo.svg';

// Styles.
import PropTypes from 'prop-types';

const propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  theme: PropTypes.string,
};

const defaultProps = {
  theme: 'light',
};

const Logo = (props) => {
  return <LogoIcon height={32} />;
};

Logo.propTypes = propTypes;
Logo.defaultProps = defaultProps;

export default Logo;